var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowToUse3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 232,
    viewBox: "0 0 356 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2524_98345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 280,
    height: 156,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 33,
    width: 116,
    height: 116,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 45,
    width: 92,
    height: 37,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 90,
    width: 57,
    height: 7,
    fill: "#F9FAFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 105,
    width: 83,
    height: 7,
    fill: "#F9FAFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 120,
    width: 83,
    height: 7,
    fill: "#F9FAFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 135,
    width: 76,
    height: 7,
    fill: "#F9FAFB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 33.5,
    width: 115,
    height: 115,
    rx: 7.5,
    fill: "white",
    stroke: "#53B1FD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 45,
    width: 92,
    height: 37,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 90,
    width: 92,
    height: 7,
    fill: "#F9FAFB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 105,
    width: 67,
    height: 7,
    fill: "#F9FAFB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 120,
    width: 83,
    height: 7,
    fill: "#F9FAFB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 135,
    width: 51,
    height: 7,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.56 124.44C176.841 124.721 176.999 125.103 176.999 125.5C176.999 125.898 176.841 126.279 176.56 126.56L162.06 141.06C161.779 141.341 161.398 141.499 161 141.499C160.603 141.499 160.221 141.341 159.94 141.06L153.44 134.56C153.175 134.276 153.031 133.9 153.038 133.511C153.044 133.122 153.202 132.751 153.476 132.476C153.751 132.202 154.122 132.045 154.511 132.038C154.899 132.031 155.275 132.175 155.56 132.44L161 137.88L174.44 124.44C174.721 124.159 175.103 124.001 175.5 124.001C175.898 124.001 176.279 124.159 176.56 124.44Z",
    fill: "#53B1FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2524_98345",
    x: 0,
    y: 0,
    width: 356,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2524_98345"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2524_98345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2524_98345",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUse3);
export default __webpack_public_path__ + "static/media/how_to_use_3.a9fc9d87cec0da1c3b8e77395a9c3168.svg";
export { ForwardRef as ReactComponent };